// This file was generated by figma/utils.mjs
export const CARDS_NAMES = {
  AMEX: 'Amex',
  APPLEPAY: 'Applepay',
  CASHPAY: 'CashPay',
  CIRRUS: 'Cirrus',
  DINERSCLUB: 'Dinersclub',
  DISCOVER: 'Discover',
  GENERICBANK: 'GenericBank',
  JCB: 'Jcb',
  MAESTRO: 'Maestro',
  MASTERCARD: 'Mastercard',
  UNIONPAY: 'Unionpay',
  VISA: 'Visa',
} as const
